import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {JwtHelperService} from "@auth0/angular-jwt";
import moment from "moment";
import {AuthtokenResponse} from "../shared/model/response/auth/authtoken-response.model";

@Injectable()
export class AuthenticationService{

  public _user = new BehaviorSubject<AuthtokenResponse>(null);

  private jwtKey: string = "accessToken"
  private refreshJwtkey: string = "refreshToken"

  constructor() {
  }

  /**
   * get all the incoming information from the token
   * @private
   */
  private getTokenData(): AuthtokenResponse {
    const jwtHelper = new JwtHelperService();
    return jwtHelper.decodeToken(localStorage.getItem(this.jwtKey));
  }

  public getAccessToken(): string {
    return localStorage.getItem(this.jwtKey)
  }

  public getRefreshToken(): string {
    return localStorage.getItem(this.refreshJwtkey)
  }

  public isSocialAccount(): boolean {
    const user = this._user.value
    if (!user) return false
    if (user.socialProvider === 'GOOGLE') return true
    return !!user.email && user.email.endsWith("gmail.com")
  }

  /**
   * set the token to the local store and emit the user.
   * @param token
   * @param refreshToken
   */
  setSession(token: string, refreshToken?: string) {

    if (token) {
      localStorage.setItem(this.jwtKey, token)

      if (refreshToken) {
        localStorage.setItem(this.refreshJwtkey, refreshToken)
      }

      this._user.next(this.getTokenData());
    }
  }

  /**
   * remove current logged user from context adn storage.
   */
  removeSession() {
    localStorage.removeItem(this.jwtKey)
    localStorage.removeItem(this.refreshJwtkey)
    this._user.next(null);
  }

  /**
   * Check the loggedin user status, if it's still valid also.
   */
  isAuthenticated() {
    const hasToken = !!localStorage.getItem(this.jwtKey);
    return hasToken && !this.isExpired();
  }

  //todo deprecated
  isPrivilegedUser() {
    if (!this._user) return false

    return this._user.value.role !== "NORMAL"
  }

  hasPrivilegeRole(role: string) {
    if (!this._user) return false
    return role !== "NORMAL"
  }

  /**
   * Automatically login user from session upon refresh and liekwise.
   */
  autoLogin() {
    const hasToken = !!localStorage.getItem(this.jwtKey);
    if (!hasToken || this.isExpired()) {
      this.removeSession();
      return;
    }

    const loggedUser: AuthtokenResponse = this.getTokenData();
    if (loggedUser) {
      this._user.next(loggedUser);
    }
  }

  /**
   * Check if access token exists or has already expired.
   */
  isExpired() {
    const tokenData: AuthtokenResponse = this.getTokenData();

    if (tokenData != null) {
      //moment Js expects time to be in seconds not in milliseconds, therefore multiply by 1000
      const expirationDate = moment(tokenData.exp * 1000)
      const issueDate = moment(tokenData.iat * 1000)

      const isBeforeExpiration = moment().isBefore(expirationDate);
      const isAfterIssueDate = moment().isSameOrAfter(issueDate);

      return !(isAfterIssueDate && isBeforeExpiration)
    }
    return false;
  }

}

